import { FormState } from '@/state'
import { formStateActions } from '@/state/actions'
import { useComputed } from '@preact/signals-react'
import { Select } from 'antd'

export default function RenderMobileEntityOptions() {
  const entityRendered = useComputed(() =>
    FormState.currentForm.value.filter((entity) => entity.permission?.read)
  )

  const entityOptions = useComputed(() =>
    entityRendered.value.map((entity) => ({
      value: entity.name as string,
      label: (entity.label ?? entity.name)?.toUpperCase() as string,
    }))
  )

  const handleSetCurrentEntity = (entityName: string) => {
    const entitySelectedOption = entityRendered.value.find(
      (item) => item.name === entityName
    )
    if (entitySelectedOption) {
      formStateActions.setCurrentEntity(entitySelectedOption)
    }
  }

  if (!FormState.currentEntity.value || entityOptions.value.length === 0) {
    return null
  }

  return (
    <Select
      className='entity-selector'
      options={entityOptions.value}
      onChange={handleSetCurrentEntity}
      value={FormState.currentEntity.value?.name}
    />
  )
}
